import { FC, memo } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'
import { Eye } from 'components/icons'

type Props = ButtonProps

const DetailsButton: FC<Props> = ({ children, ...props }) => {
  return (
    <Button variant="outline" leftIcon={<Eye />} {...props}>
      {children}
    </Button>
  )
}

export default memo(DetailsButton)
